export function createModelServingGatewayClient(transport) {
    return {
        /**
         * List every tenant's model deployments, as a state and a version
         *
         * Requires scope: model-serving:platform:read
         */
        listPlatformModelDeployments(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/model-deployments",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * PUT /internal/v1/tenants/{tenantId}/model-deployments
         *
         * Requires scope: model-serving:configure
         */
        configureModelDeployment(tenantId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/model-deployments`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/model-deployments/{deploymentId}/inferences
         *
         * Requires scope: model-serving:invoke
         */
        invokeApprovedModel(tenantId, deploymentId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/model-deployments/${encodeURIComponent(deploymentId)}/inferences`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=model-serving-gateway.js.map